import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import isEmpty from 'lodash/isEmpty';
import take from 'lodash/take';
import * as api from 'dashboard/resources/top-selling-games.api';
import template from './top-selling-games-widget.html';

const mapStateToThis = ({ dictionary, session }) => {
  const { retailer, locale } = session;
  const terms = dictionary.terms[locale];
  return {
    retailer,
    terms,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog')
class TopSellingGamesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.rankings = [
      { id: 0, title: this.gettextCatalog.getString('In the {{state}}', { state: this.terms.STATE.singular.toLowerCase() }) },
      { id: 1, title: this.gettextCatalog.getString('In your store') },
    ];
    this.ranking = 0;
    this.activeTabIdx = 0;
    this.loadDataAsync(() =>
      Promise.all([this.getTop10(), this.getTopSellersByPrice()]).then((results) => {
        this.isEmptyTopRankings = isEmpty(results[0]);
        this.isEmptyTopSellers = isEmpty(results[1]);
      })
    );
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getTop10() {
    return api.fetchTop10(this.retailerId).then((data) => {
      this.topAll = data;
      this.sortTop10();
      return Promise.resolve(this.topAll);
    });
  }

  sortTop10() {
    if (this.ranking === 0) {
      this.top10 = take(this.topAll.filter((t) => t.stateSalesRank > 0).sort(this.stateSalesComparator.bind(this)), 10);
    } else {
      this.top10 = take(this.topAll.filter((t) => t.storeSalesRank > 0).sort(this.storeSalesComparator.bind(this)), 10);
    }
  }

  stateSalesComparator({ stateSalesRank: a }, { stateSalesRank: b }) {
    return this.customComparator(a, b);
  }

  storeSalesComparator({ storeSalesRank: a }, { storeSalesRank: b }) {
    return this.customComparator(a, b);
  }

  customComparator(a, b) {
    if (a === b) {
      return 0;
    }
    if (a === 0) {
      return 1;
    }
    if (b === 0) {
      return -1;
    }
    return a < b ? -1 : 1;
  }

  getTopSellersByPrice() {
    return api.fetchTopSellersByPrice(this.retailerId).then((data) => {
      this.topSellersByPrice = data.reduce((prev, curr) => {
        let added = prev.find((search) => search.pricePoint === curr.pricePoint);
        if (!added) {
          added = {
            pricePoint: curr.pricePoint,
          };
          prev = prev.concat(added);
        }

        const index = curr.salesRank === 1 || !added.gameName1 ? 1 : 2;
        added[`gameName${index}`] = curr.gameName;
        added[`gameNumber${index}`] = curr.gameNumber;
        added[`salesRank${index}`] = curr.salesRank;
        added[`imageURL${index}`] = curr.imageURL;
        return prev;
      }, []);
      return Promise.resolve(this.topSellersByPrice);
    });
  }
}

export default class TopSellingGamesWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = TopSellingGamesWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/top-selling-games/top-selling-games-widget-component.js